import { gql } from "@apollo/client";

export const GET_PRODUCT_DETAILS = gql`
  query sellerProductsDetails($productId: Int!) {
    sellerProductDetails(product_id: $productId) {
      sku
      name
      categories {
        id
        name
        level
      }
      brand
      model_name
      model_number
      seller_reference
      short_description
      description
      images {
        id
        url
        label
        roles
      }
      price
      special_price {
        value
        start_date
        end_date
      }
      free_shipping
      return_policy
      warranty
      shipping_method
      quantity
      weight
      package_width
      package_height
      package_depth
      type_id
      custom_attributes {
        code
        value
        content
        label
      }
      variants {
            id
            price
            quantity
            sku
            image {
                label
                roles
                url
            }
            attributes {
                code
                content
                label
                value
            }
      }
      product_status
      status
      deactivation_reason {
        description
        reason
      }
      created_at
      updated_at
    }
  }
`;